export default __webpack_public_path__ + "static/media/device-cover.1cbedab7.svg";